import {
  USER_SET_IS_LOGIN,
  USER_SET_PERMISSIONS,
  USER_SET_PROFILE,
  USER_PROFILE_SET_ERROR,
  SET_USER_SETTINGS,
  SHOW_USER_SETTINGS_LOADER,
  HIDE_USER_SETTINGS_LOADER,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  isLogin: undefined,
  permissions: undefined,
  profile: {},
  isError: false,
  user_settings: {
    email: "",
    dashboard_type: "quality_cohort_report",
  },
  user_settings_loading: true,
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_USER_SETTINGS_LOADER:
      return {
        ...state,
        user_settings_loading: true,
      };
    case HIDE_USER_SETTINGS_LOADER:
      return {
        ...state,
        user_settings_loading: false,
      };
    case SET_USER_SETTINGS:
      return {
        ...state,
        user_settings: {
          ...state.user_settings,
          ...action.payload,
        },
      };
    case USER_SET_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };
    case USER_PROFILE_SET_ERROR:
      return {
        ...state,
        isError: action.payload,
      };
    case USER_SET_IS_LOGIN:
      state = {
        ...state,
        isLogin: action.payload,
      };
      break;
    case USER_SET_PERMISSIONS:
      state = { ...state, permissions: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default user;
